/**
 * //////////////////////////////////////////////////
 * REDUCKSメインファイル
 * --------------------------
 *
 * セレクタ、オペレーション、サガ、リデューサを束ねるメインファイル。
 * Reducksの他のコンポーネント（managerUsers）と結合するために、主にducks/index.jsファイルにエクスポートされます。
 * ///////////////////////////////////////////////////
 */

import * as watchersSagas from './watchersSagas';

export const managerUserWatcherSagas = Object.values(watchersSagas);
export {default as mangerUserListSelectors} from "./selectors";
export {default as managerUserListOperations} from "./operations";
export {default as managerUserListTypes} from "./types";
export {default as managerUserForms} from "./forms"

export {managerUserListState, default as managerUserReducer} from './reducers';
